/* eslint-env browser */
// eslint-disable-next-line import/no-mutable-exports
let windowObject;

/* istanbul ignore next */
if (typeof window === 'undefined') {
  windowObject = global;
} else {
  windowObject = window;
}

export default windowObject;
